<template>
  <div class="Contract">
    <div class="page-title">{{ title }}</div>
    <div>
      <ATable
        ref="table"
        :loading="loading"
        buttons-width="250px"
        min-height="200px"
        max-height="758px"
        :data="items_table"
        :summaryFields="summaryFields"
        :placeholder="placeholder"    
        :search_field="search_field"
        :summaryTitleColumnIndex="5"
        :disable_insert="!has_grant_write"
        show-summary
        hide-pagination
        border
        @selection-change="handleSelectionChange"
        @row-click="handleClickRow"
        @clicked-create="handleClickedCreate"
      >
        <div slot="search">
          <div class="inline">
            <APeriodSelector 
              ref="period" 
              :value="search_period" 
              hide-select
              @change="handleChangePeriod" 
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
            >검색(F5)</el-button>
          </div>
          <div class="inline" style="margin-left:20px">
            <el-button
              size="mini"
              round
              @click="handleSelectColumn"
            >컬럼설정</el-button>
          </div>
          <div class="inline" style="margin-left:20px; margin-top:5px">
            <el-button
              size="mini"
              round
              @click="handleClickExcelPeriod"
            >
              수주 상세 다운로드
            </el-button>
          </div>
        </div>
        <el-table-column 
          type="selection" 
          align="center"
          :width="$width.selection"
        />
        <el-table-column
          type="index"
          label="No"
          :index="handleIndex"
          :width="$width.index"
        />
        <el-table-column
          prop="contract_date"
          label="수주일"
          v-if="this.column_visible.contract_date"
          :width="$width.date"
        />
        <el-table-column 
          prop="code" 
          label="수주번호" 
          v-if="this.column_visible.code"
          width="100" 
        />
        <el-table-column
          prop="customer_name"
          label="거래처"
          v-if="this.column_visible.customer_name"
          width="100"
          show-overflow-tooltip
        />        
        <el-table-column
          prop="product_name"
          label="품목"
          min-width="120"
          v-if="this.column_visible.product_name"
          show-overflow-tooltip
        />
        <el-table-column 
          prop="serial_code"
          :label="$t('lang.serial')" 
          v-if="this.column_visible.serial_code"
          width="80"         
        />
        <el-table-column 
          prop="destination" 
          label="도착지" 
          v-if="this.column_visible.destination"
          show-overflow-tooltip 
        />
        <el-table-column
          prop="amount"
          label="수량"
          class-name="cell-number"
          v-if="this.column_visible.amount"
          :width="$width.amount"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="supply_price"
          label="공급가액"
          class-name="cell-number"
          v-if="this.column_visible.supply_price"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="tax"
          label="세액"
          class-name="cell-number"
          v-if="this.column_visible.tax"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="price"
          label="가격"
          class-name="cell-number"
          v-if="this.column_visible.price"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column 
          prop="status_flag" 
          label="상태" 
          v-if="this.column_visible.status_flag"
          width="50"
        >
          <template slot-scope="scope">{{resolveStatus(scope.row.status_flag)}}</template>
        </el-table-column>
        <el-table-column
          prop="delivery_date"
          label="납품일"
          v-if="this.column_visible.delivery_date"
          :width="$width.date"
        />
        <el-table-column
          prop="created_user_name"
          v-if="this.column_visible.created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          v-if="this.column_visible.modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          v-if="this.column_visible.created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          v-if="this.column_visible.modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <div slot="buttons">
          <el-button
            :disabled="selection.length < 1"
            @click="handleClickPrint"
          >스티커인쇄</el-button>
          <el-button
            :disabled="selection.length < 1"
            @click="handleClickStatementSelect"
          >매출전표</el-button>
        </div>
      </ATable>
    </div>    
    <el-dialog
      custom-class="form-dialog"
      top="0"
      :width="showPyungProcessingCost ? '1500px' : '1300px'"
      :title="$t('title.contract_reg')"
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      destroyOnClose
      @opened="handleOpened"
    >
      <ContractForm 
        ref="form" 
        v-if="dialog_visible"
        :data="form_data" 
        :has_grant_write="has_grant_write"
        @completed="handleCompleted" 
        @updated="handleUpdated"
      />
    </el-dialog>
    <el-dialog
      custom-class="form-dialog"
      title="스티커 인쇄"
      top="0"
      :visible.sync="dialog2_visible"
      destroyOnClose
    >
      <ContractPrint
        v-if="dialog2_visible"
        :data="selection"
        @completed="handleCompletedPrint" 
      />
    </el-dialog>
    <el-dialog
      custom-class="form-dialog"
      title="품목 선택"
      top="0"
      :visible.sync="dialog3_visible"
      destroyOnClose
    >
      <SaleStatementSelect
        v-if="dialog3_visible"  
        :data="selection"
        @completed="handleCompletedStatementSelect" 
      />
    </el-dialog>
    <el-dialog
      title="매출품목인쇄"
      custom-class="form-dialog"
      top="100"
      :visible.sync="dialog4_visible"
      :close-on-click-modal="false"
      destroyOnClose
    >
      <SaleStatementPrint 
        ref="statement" 
        v-if="dialog4_visible" 
        style="height: 600px;"
        :data="selectedData"
        @completed="handleCompletedStatementPrint"
      />
    </el-dialog>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      title="컬럼설정"
      width="50%"
      :visible.sync="column_dialog_visible"
      destroyOnClose
      :close-on-click-modal="false"    
    >
      <ASelectColumnForm 
        ref="form" 
        v-if="column_dialog_visible"
        :data="column_form_data"
        @completed="handleCompletedColumnForm" 
      />
    </el-dialog>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      title="수주 상세 다운로드"
      width="20%"
      :visible.sync="excel_dialog_visible"
      destroyOnClose
      :close-on-click-modal="false"    
    >
      <APeriodSelector 
        v-if="excel_dialog_visible"
        ref="periodExcel"
        :value="excel_period"
        style="width:290px; margin:0 auto;"
        hide-select
        @change="handleChangeExcelPeriod"
      />
      <el-footer height="40px">
        <el-button
          type="primary"
          v-shortkey="['f4']"        
          @shortkey.native="handleCompletedDownloadExcel"
          @click="handleCompletedDownloadExcel"
        >완료 (F4)</el-button>
      </el-footer>
    </el-dialog>

  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import { user_config } from "@/common/mixins/user_config";
import { company_info } from "@/common/mixins/company_info";
import ContractForm from "./ContractForm";
import ContractPrint from "./ContractPrint";
import SaleStatementSelect from "./SaleStatementSelect";
import SaleStatementPrint from '@/spa/Common/SaleStatementPrint'
import ASelectColumnForm from "../../shared/ASelectColumnForm";
import export2csv from "@/common/function/export2csv";

export default {
  name: "Contract",
  mixins: [form_container, authority_level, user_config, company_info],
  components: { ContractForm, ContractPrint, SaleStatementSelect, SaleStatementPrint, ASelectColumnForm },
  data() {
    return {
      company: {
        show_pyung_processing_cost: false
      },
      title: this.$t("title.contract"),
      search_field: ["code", "customer_name", "product_name"],
      placeholder: '수주번호, 거래처, 품목',
      search: {
        keyword: "",
        status: []
      },
      items: [],
      summaryFields: ['supply_price', 'tax', 'price'],
      dialog_visible: false,
      dialog2_visible: false,
      dialog3_visible: false,
      dialog4_visible: false,
      isShowSearchDetail: false,
      form_data: undefined,
      period: {},
      excel_period: {value: '1m'},
      loading: false, 
      selection: [],
      print_type: 1,
      updated: false,
      search_period: {value: '0d'},
      selected_data: null,
      column_dialog_visible: false,
      excel_dialog_visible: false,
      column_form_data: {},
      config_item_name: "contract_stat_column",
      column_visible: {
        contract_date: true,
        code: true,
        customer_name: true,      
        serial_code: true,
        product_name: true,
        destination: true,      
        amount: true,      
        supply_price: true,
        tax: true,      
        price: true,
        status_flag: true,
        delivery_date: true,
        created_user_name: true,
        modified_user_name: true,
        created_at: true,
        modified_at: true,
      },
      column_items: [
        {key: "contract_date", value: "수주일", fixed: true},
        {key: "code" , value: "수주번호", fixed: true},
        {key: "customer_name" , value: "거래처", fixed: true},
        {key: "serial_code" , value: "품번", fixed: false},
        {key: "product_name" , value: "품목", fixed: false},
        {key: "destination" , value: "도착지", fixed: false},
        {key: "amount" , value: "수량", fixed: false}, 
        {key: "supply_price" , value: "공급가액", fixed: true},
        {key: "tax" , value: "세액", fixed: true},
        {key: "price" , value: "가격", fixed: true},
        {key: "status_flag" , value: "상태", fixed: false},
        {key: "delivery_date" , value: "납품일", fixed: false},
        {key: "created_user_name" , value: "등록자", fixed: false},
        {key: "modified_user_name" , value: "수정자", fixed: false},
        {key: "created_at" , value: "등록일", fixed: false},
        {key: "modified_at" , value: "수정일", fixed: false},
      ],
      user_data: {},
    };
  },
  computed: {
    ...mapGetters(["userData"]),
    showPyungProcessingCost() {
      return this.company.show_pyung_processing_cost;
    },
    searchTags: function() {
      let tags = [];
      let tag = {};
      tag.name = this.util.getPeriodText(this.search.period);
      tag.fixed = true;
      tags.push(tag);
      if (this.search.keyword.length > 0) {
        tag = {};
        tag.name = "검색어: " + this.search.keyword;
        tags.push(tag);
      }
      if (this.search.status.length > 0) {
        tag = {};
        tag.name = "상태: " + this.search.keyword;
        tags.push(tag);
      }
      return tags;
    },
    items_table: function() {
      return this.getSerialCode(this.items);
    }, 
    has_grant_write() {
      return this.isWriteLevel('contract_stat');
    },
  },
  watch: {
    table_config() {
      this.loadConfig()
    },
  },
  mounted() {    
    this.loadConfig()
    this.column_form_data.columns = this.column_items;
    this.$nextTick(() => { this.loadData(); })   
  },
  methods: {
    handleChangePeriod(value) {
      this.period = value;
    },
    handleChangeExcelPeriod(value) {
      this.excel_period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) { return; }
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.api.listContract(this.period).then(res => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, "수주", res.message);
          return;
        }                
        this.items = res.data;
        this.arrangeData();
      });
      this.api.listUserConfig(this.userData.id).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }        
        this.user_data = res.data;
        this.column_form_data.selected_columns = this.getSelectedColumnData(this.user_data, this.config_item_name);
        let selected_columns = JSON.parse(JSON.stringify(this.column_form_data.selected_columns));
        this.column_items.forEach(item => {
          if (!selected_columns.find( findItem => findItem === item.key && item.fixed )) {
            this.column_form_data.selected_columns.push(item.key);
          }
        });
        this.updateTableColumn(this.column_form_data.selected_columns);
      });   
    },    
    getSerialCode(data) {      
      for (let item of data) {        
        if (item.details === undefined) { continue; }
        let serial_code = '';
        item.details.forEach(detail_item => {
          detail_item.serial_code = this.util.getGoodsSerialCode(detail_item);
          if (detail_item.serial_code) {
            if (serial_code) { serial_code += ',' }
            serial_code += detail_item.serial_code;
          }
        })
        item.serial_code = serial_code;
      }      
      return data;
    },
    arrangeData() {
      for (let i = 0; i < this.items.length; ++i) {
        this.dataArrange(i);
      }
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    /** 데이터 선택 */
    handleClickRow(data) {
      this.openDialog(data);
    },
    /** 신규 등록*/
    handleClickedCreate() {
      if (!this.has_grant_write) { return; }
      this.form_data = undefined; //추가생성시 초기화
      // this.openDialog();
      this.$router.push("/sale/contract_reg");
    },
    /**  폼 처리 완료 */
    handleCompleted(result) {
      this.dialog_visible = false;
      this.form_data = undefined;
      if (!result) { return; }
      if (typeof result === 'number') {
        let index = this.items.findIndex(item => item.id === result);
        if (index > -1) {
          this.items.splice(index, 1);
        }
      } else {
        let index = this.items.findIndex(item => item.id === result.id);
        if (index > -1) {
          this.items.splice(index, 1, result);
        } else {
          this.items.splice(0, 0, result);
        }
      }
      this.arrangeData();
      this.$refs.table.clearSelection();
      this.loadData();
    },
    dataArrange(index) {
      this.items[index].amount = 0;
      this.items[index].tax = 0;
      this.items[index].cost = 0;
      this.items[index].supply_price = 0;
      for (let j = 0; j < this.items[index].details.length; ++j) {
        this.sumCalculation(index, j);
      }
      this.productNaming(index);
    },
    sumCalculation(index, j) {
      this.items[index].amount += this.items[index].details[j].amount;
      this.items[index].tax += this.items[index].details[j].tax;
      this.items[index].cost += this.items[index].details[j].cost;
      this.items[index].supply_price += this.items[index].details[
        j
      ].supply_price;
    },
    productNaming(index) {
      if (this.items[index].details.length > 1) {
        this.items[index].product_name = this.items[index].details[0].product_name + " 외 " + (this.items[index].details.length - 1) + "건";
      } else {
        this.items[index].product_name = this.items[index].details[0].product_name;
      }
    },        
    /** 다이얼로그 팝업 */
    openDialog(data) {
      let clone = data ? this.util.looseClone(data) : undefined;
      this.form_data = clone;      
      this.dialog_visible = true;
      this.updated = false;
    },
    resolveTypeFlag(value) {
      return this.system.options.resolve_customer_type_flag(value);
    },
    resolveStatus(value) {
      let ret = "";
      switch (value) {
        case "0":
          ret = "진행";
          break;
        case "1":
          ret = "수주";
          break;
        case "2":
          ret = "취소";
          break;
      }
      return ret;
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    handleClickPrint() {
      this.dialog2_visible = true;
    },
    handleCompletedPrint() {
      this.dialog2_visible = false;
    },
    handleClickStatementSelect() {
      this.dialog3_visible = true;
    },
    handleCompletedStatementSelect(result) {
      this.dialog3_visible = false;
      if (!result) { return; }
      this.selectedData = result;
      this.dialog4_visible = true;
    },
    handleCompletedStatementPrint() {
      this.dialog4_visible = false;
    },
    handleUpdated() {      
      this.updated = true;
    },
    handleSelectColumn() {
      this.column_form_data.fixed_columns = this.column_items.filter(item => item.fixed === true);
      this.column_dialog_visible = true;
    },
    handleCompletedColumnForm(result) {      
      this.column_dialog_visible = false;
      if (!result) return;
      this.setSelectedColumnData(this.user_data, this.column_items, result, this.config_item_name);
      this.updateTableColumn(result);
    },
    updateTableColumn(data) {
      this.column_items.forEach( item => {          
        this.column_visible[item.key] = false;
      });
      if (data.length > 0) {
        this.column_items.forEach( item => {
          if (data.find(find_item => find_item === item.key)) {
            this.column_visible[item.key] = true;
          }
        });
      }
    },
    handleClickExcelPeriod() {      
      this.excel_dialog_visible = true;
    },
    handleCompletedDownloadExcel() {
      this.excel_dialog_visible = false;
      this.downloadContractDetailExcel();
    },
    downloadContractDetailExcel() {
      this.api.listContractDetailExcel(this.excel_period).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.downloadExcel(res.data);
      });
    },
    downloadExcel(items) {
      let fields = [
        {label: 'No', value: 'index'},
        {label: '수주일', value: 'contract_date'},
        {label: '수주번호', value: 'code'},
        {label: '거래처', value: 'customer_name'},
        {label: '품목', value: 'product_name'},
        {label: '품번', value: 'serial_code'},
        {label: '규격', value: 'size'},
        {label: '비고', value: 'desc'},
        {label: '현장', value: 'field'},
        {label: '도착지', value: 'destination'},
        {label: '수량', value: 'amount'},
        {label: '단위', value: 'unit_name'},
        {label: '단가', value: 'cost'},
        {label: '공급가액', value: 'supply_price'},
        {label: '세액', value: 'tax'},
        {label: '가격', value: 'price'},
        {label: '상태', value: 'status_flag'},
        {label: '납품일', value: 'delivery_date'},
        {label: '매출등록일', value: 'sale_date'},
        {label: '등록자', value: 'created_user_name'},
        {label: '수정자', value: 'modified_user_name'},
        {label: '등록일', value: 'created_at'},
        {label: '수정일', value: 'modified_at'},
      ];
      let index = items.length;
      items.forEach((item) => {
        item.index = index--;
        item.created_at = item.created_at.substr(0, 10);
        item.modified_at = item.modified_at.substr(0, 10);
        item.cost = this.util.addComma(item.cost);
        item.supply_price = this.util.addComma(item.supply_price);
        item.tax = this.util.addComma(item.tax);
        item.price = this.util.addComma(item.price);
        item.serial_code = " " + this.util.getGoodsSerialCode(item);
      })
      export2csv.export(items, fields, "contract_details");
    }
  }
};
</script>